export default __webpack_public_path__ + "static/media/img-06-magic.7ce07570.jpg";